import { Camera } from "@capacitor/camera";
import * as E from "fp-ts/Either";
import { pipe } from "fp-ts/lib/function";
import * as TE from "fp-ts/TaskEither";
import React from "react";
import { isDefined } from "../components/Generic/IsDefined";
import { taskEither } from "../either";
import { getImageBase64, getPhotoFromCamera } from "../utils/imageUtils";

type Params = {
  onSelectFiles?: (files: string[]) => void;
};

export default function useFilePicker(params?: Params) {
  const [files, setFiles] = React.useState<string[]>([]);

  const chooseFromGallery = async () => {
    const pickResult = await taskEither(
      Camera.pickImages({
        width: 1440,
        height: 1440,
        limit: 1,
      })
    );

    if (pickResult.type === "Left") {
      console.log("Error picking images", pickResult.value);
      return;
    }

    const { photos } = pickResult.value;

    const base64Files = await Promise.all(photos.map((photo) => getImageBase64(photo)));

    const newFiles = base64Files.filter(isDefined);

    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
    params?.onSelectFiles?.(newFiles);
  };

  const takePhoto = async () => {
    const getBase64PhotoFromCamera = pipe(
      TE.tryCatch(getPhotoFromCamera, E.toError),
      TE.chain((photo) => TE.tryCatch(() => getImageBase64(photo), E.toError))
    );

    pipe(
      await getBase64PhotoFromCamera(),
      E.fold(
        ($error) => console.error(`Error getting photo from camera: ${$error}`),
        (photo) => {
          if (photo === undefined) return;
          setFiles((prevFiles) => [...prevFiles, photo]);
          params?.onSelectFiles?.([photo]);
        }
      )
    );
  };

  return { files, chooseFromGallery, takePhoto };
}
